angular.module('app.controllers.non-paginated-forms.supplier-attachment', [])
    .controller("SupplierAttachmentController", function ($scope, $http, appConstants) {

        $scope.aversion = appConstants.version;
        $scope.fileselected = false;
        $scope.filetoolarge = false;
        $scope.filessubmitted = [];
        $scope.invalidKey = false;
        $scope.supplierkey = "NULL";
        $scope.supplierid = "";
        var resp = [];  // new array


        function getParametersByName(name) {
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(window.location.href);
            if (results === null)
                return "";
            else
                return decodeURIComponent(results[1].replace(/\+/g, " "));
        }

        function verifyCheckDigits(supplierKey) {
            var add1 = 0, add2 = 0, add3 = 0, add4 = 0, add5 = 0, addId = 0, addId2 = 0, checkdigits = "", checksum = 0, checkit = "";
            if (supplierKey.length < 18)
                return false;
            else
                add1 = 0 + parseInt(supplierKey.substr(2, 2));
            add2 = 0 + parseInt(supplierKey.substr(4, 2));
            add3 = 0 + parseInt(supplierKey.substr(8, 2));
            add4 = 0 + parseInt(supplierKey.substr(10, 2));
            add5 = 0 + parseInt(supplierKey.substr(12, 2));
            addId = 0 + (parseInt($scope.supplierid) + 95) * 2;
            addId2 = parseInt($scope.supplierid) + 11;
            //alert(addId2);
            addId2 = parseInt(addId2.toString().substr(0, 2));
            // alert (add1 + add2 + add3 + add4 + add5 + addId + addId2);
            checkdigits = supplierKey.substr(16, 2);
            checksum = parseInt(add1) + parseInt(add2) + parseInt(add3) + parseInt(add4) + parseInt(add5) + parseInt(addId) + parseInt(addId2);
            var len = checksum.toString().length;
            checkit = checksum.toString().substr(len - 2, 2);
            var result = (parseInt(checkit) == checkdigits) ? true : false;
            // alert(addId + "-" + result + checkit + "-" + checkdigits);
            return result;
        }


        $scope.setIfValidKey = function () {
            // alert($scope.invalidKey);  
            $scope.supplierid = getParametersByName('supplierid');
            var supplierKey = getParametersByName('supplierkey');
            var isValidKey = verifyCheckDigits(supplierKey);
            //  alert (isValidKey + " - " + supplierKey);
            $scope.invalidKey = (isValidKey) ? false : true;
            $scope.supplierkey = supplierKey;
            //alert($scope.invalidKey);         
            $scope.$digest();

        };

        $scope.submit = function () {
            var fd = new FormData();
            fd.append("supplierid", $scope.supplierid);
            fd.append("supplierkey", $scope.supplierkey);
            fd.append("file", jQuery("#file").get(0).files[0]);

            if ($scope.filessubmitted.indexOf(jQuery("#file").get(0).files[0].name) > -1) {
                document.getElementById("supmessage").innerHTML = "<p><b style='color: #95485C; font-family: Verdana, Helvetica, Arial, Geneva, sans-serif; font-size: 11.9999990463257px;'>This file has been submitted previously. Please select a different file.</b><br style='color: rgb(35, 31, 32); font-family: Verdana, Helvetica, Arial, Geneva, sans-serif; font-size: 11.9999990463257px;' /> <br style='color: rgb(35, 31, 32); font-family: Verdana, Helvetica, Arial, Geneva, sans-serif; font-size: 11.9999990463257px;' /></p>";
                return;
            }

            $http.post('/swgasws/resources/form/supplierattachment/add', fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            })
                .success(function (data) {
                    switch (data.status) {
                        case 'success':
                            $scope.filessubmitted.push(jQuery("#file").get(0).files[0].name);
                            if ($scope.filessubmitted.length < 10) {
                                document.getElementById("supmessage").innerHTML = "<p><span class='form-sub-good'>" + data.message + " Please use the form to send additional documents!</span></p>";
                            }
                            else {
                                document.getElementById("supmessage").innerHTML = "<p><span class='form-sub-error'>Forms are limited to 10 attachments maximum. If you have further attachments please submit them to spd@swgas.com.</span></p>";
                            }
                            break;
                        case 'badrequest':
                            document.getElementById("supmessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " Please try again later.  The Webmaster has been notified of the following submission problem(s): <br /> " + resp[2] + "</span></p>";
                            break;
                        case 'invalidkey':
                            document.getElementById("supmessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified of the following submission problem(s): <br /> </span></p>";
                            break;
                        default:  // all other errors
                            document.getElementById("supmessage").innerHTML = "<p><span class='form-sub-error'>" + data.message + " The Webmaster has been notified.</span></p>";

                    }  // end switch          
                    $scope.isDisabled = true;
                    // end success 
                })
                .error(function (data) {
                    if (data.result) {
                        response = response + "An Error Occurred"; //handle 500 Error here
                    }
                    document.getElementById("supmessage").innerHTML = "<p><span class='form-sub-error'>" + response + "Your attachment has NOT been sent due to maintenance.  We apologize for the inconvenience at this time. Please try again later.</span></p>";
                });

        };
    });